module.exports = __webpack_public_path__ + "static/tabc-badge-favicon-8a034d32bf9e5b4f08d4dc10c928468f.png";